module.exports = __webpack_public_path__ + "static/img/10.1093623e.png";